import * as LucideIcons from "lucide-react";
import * as ReactIcons from "react-icons/fa";
import * as MaterialIcons from "react-icons/md";
import * as BootstrapIcons from "react-icons/bs";
import * as FeatherIcons from "react-icons/fi";
import { IoAlertCircleOutline } from "react-icons/io5";
import React from "react";

interface DynamicIconProps {
  iconName: string;
  lib: string;
  className?: string;
  size?: number;
}

/**
 * Componente para renderizar ícones dinamicamente baseado na biblioteca e nome do ícone
 * Suporta: Lucide React, Font Awesome, Material Design, Bootstrap Icons e Feather Icons
 */
export const DynamicIcon: React.FC<DynamicIconProps> = ({
  iconName,
  lib,
  className = "",
  size,
}) => {
  // Função para obter o ícone correto baseado na biblioteca
  const getIcon = () => {
    let IconComponent;
    const libLower = lib.toLowerCase();

    switch (libLower) {
      case "lucide":
      case "lucide-react":
        IconComponent = (LucideIcons as any)[iconName];
        break;
      case "fontawesome":
      case "fa":
        IconComponent = (ReactIcons as any)[iconName];
        break;
      case "material":
      case "md":
        IconComponent = (MaterialIcons as any)[iconName];
        break;
      case "bootstrap":
      case "bs":
        IconComponent = (BootstrapIcons as any)[iconName];
        break;
      case "feather":
      case "fi":
        IconComponent = (FeatherIcons as any)[iconName];
        break;
      default:
        console.warn(`Biblioteca de ícone não suportada: ${lib}`);
        IconComponent = null;
    }

    // Se não encontrar o ícone, retorna um ícone padrão
    if (!IconComponent) {
      console.warn(
        `Ícone "${iconName}" não encontrado na biblioteca "${lib}". Usando ícone padrão.`,
      );
      return <IoAlertCircleOutline className={className} size={size} />;
    }

    // Para Lucide React, usa a prop size
    if (libLower === "lucide" || libLower === "lucide-react") {
      return <IconComponent className={className} size={size} />;
    }

    // Para React Icons, usa className e size
    return <IconComponent className={className} size={size} />;
  };

  return <>{getIcon()}</>;
};
